export const SET_SUPPORT_MEMBER = "SET_SUPPORT_MEMBER";

const setSupportMember = (payload) => ({ type: SET_SUPPORT_MEMBER, payload });

const supportAction = { setSupportMember };
export default supportAction;
